import React from 'react';

type InputProps = {
  context: {
    employeeId?: number | null;
    jobApplicantId?: number | null;
    referralId?: number | null;
  };
};

export const ContactType = ({ context }: InputProps) => {
  let contactTypeMessage = null;
  if (context.employeeId) {
    contactTypeMessage = 'Employee';
  } else if (context.jobApplicantId) {
    contactTypeMessage = 'Job Applicant';
  } else if (context.referralId) {
    contactTypeMessage = 'Referral';
  }
  if (!contactTypeMessage) {
    return null;
  }
  return <div>{contactTypeMessage}</div>;
};
